import * as Yup from 'yup';

import { YupValidator } from '../../../../shared/core/domain/YupValidator';
import { IUserMoveForm } from '../interfaces';

export const userMoveSchema = YupValidator.composeValidatorSchema<{
  [K in keyof IUserMoveForm]: Yup.AnySchema<IUserMoveForm[K]>;
}>([
  {
    username: YupValidator.validateNonEmptyString()
      .email('Must be an email')
      .default('')
      .required('An existing tenant uuid is required'),
    confirmUsername: YupValidator.validateNonEmptyString()
      .oneOf([Yup.ref('username')], 'emails do not match')
      .default('')
      .required('Re-type the username before moving the user'),
    existingTenantUuid: YupValidator.validateNonEmptyString()
      .uuid('Must be an UUID')
      .default('')
      .required('An existing tenant uuid is required'),
    targetTenantUuid: YupValidator.validateNonEmptyString()
      .uuid('Must be an UUID')
      .default('')
      .required('A target tenant uuid is required'),
    targetTenantName: YupValidator.validateNonEmptyString()
      .default('')
      .required('A target tenant name is required'),
  },
]);
